module.exports = __webpack_public_path__ + "static/img/hmo2.24730db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hmo/hmo2.png
// module id = fW9B
// module chunks = 11